import { GlobalClassInstance } from '@commoncore/constants/GlobalClass';
import { DocumentsImplementation } from '@commoncore/implementation/DocumentsImplementation';
import { FileOperationsImplementation } from '@commoncore/implementation/FileOperationsImplementation';
import { GlobalService } from '@commoncore/services/global.service';
import { ENV_CONSTANTS } from '@env-properties/environment';
import { ENV_CONFIG } from '@env-properties/environment-config';


export class DocumentsController{
    public docsImplementation:any;
    public fileOperationsImplementation:any;
    public universalService:any;
    public router:any;
    public http:any;
    public fetchFolderData:boolean=false;
    public static singleInstance:any = null;
    public listService:any;
    public sortOrder:any;
  loggerService: any
  sessionStorageService;any;
    constructor(public globalService:GlobalService) {
      this.docsImplementation= DocumentsImplementation.getInstance(this.globalService);
      this.fileOperationsImplementation = FileOperationsImplementation.getInstance(this.globalService)
    }
    
    public static getInstance(globalService):DocumentsController{
		if(this.singleInstance == null){
			this.singleInstance = new DocumentsController(globalService);
			return this.singleInstance;
		}else{
			return this.singleInstance;
		}
	}


    public setEnvObjects(globalService){
		this.universalService=globalService.getUniversalServiceRef();
		this.router = globalService.getRouterRef();
        this.http = globalService.getHttpClientRef();   
        this.listService = globalService.getListServiceRef();
        this.loggerService = globalService.getLoggerServiceRef();
        this.sessionStorageService = globalService.getSessionStorageSvcRef();
    } 


    getDocs(){
      let limit = ENV_CONFIG["constants"]["PAGE_LIMIT"] * ENV_CONFIG["constants"]["PAGINATION_BUFFER"]
      this.universalService.nameSort == null;
      if(!this.universalService.listView || (this.universalService.listView && this.universalService.isMobileDevice)) {
        if (localStorage.sharePublicSort == this.universalService.sharePublicSortByDate) {
          this.universalService.nameSort = false;
          this.sortOrder="&sort=%2DfileCreatedDate";
        } else if (localStorage.sharePublicSort == this.universalService.sharePublicSortByUploadDate) {
          this.universalService.nameSort = false;
          //this.sortOrder=this.listService.listViewSortOrder;
          this.sortOrder='&sort=%2DcreatedDate';
        } else {
          this.universalService.nameSort = true;
          this.sortOrder='&sort=%2BobjectName';
        }
      }else{
        if (localStorage.sharePublicSort == this.universalService.sharePublicSortByUploadDate) {
          this.universalService.nameSort = false;
          this.sortOrder = this.listService.listViewSortOrder;
        } else {
          this.sortOrder = this.listService.listViewSortOrder;
          localStorage.setItem('listViewSortOrder',this.listService.listViewSortOrder);

        }
      }
      //this.sortOrder = this.listService.listViewSortOrder;
      // this.loggerService.log("inside docs controller")
        var docsUrl="";
        if(this.universalService.sharingAlbumFiles){
            docsUrl =  '/public/boards/share/' + this.universalService.shareKey + '?filterCode=applicationAndText' + this.sortOrder;
        }
        // else if(this.sortOrder.includes('createdDate')) {
        //   docsUrl = ENV_CONSTANTS.privateUrls[GlobalClassInstance.ENV_NAME]["nmsURL"] + ENV_CONFIG.commonUrls["nms"] + ENV_CONFIG.commonUrls["metaData"] + ENV_CONFIG.commonUrls["nmsRecentUpload"] + "?limit=" + limit + "&filterCode=applicationAndText" + this.sortOrder;   
        // }
        else {
          docsUrl= ENV_CONSTANTS.privateUrls[GlobalClassInstance.ENV_NAME]["nmsURL"] + ENV_CONFIG.commonUrls["nms"] + ENV_CONFIG.commonUrls["metaData"] + ENV_CONFIG.commonUrls["nmsMetadataMimeTypeFilter"] + "?limit=" + limit + "&filterCode=applicationAndText"+ this.sortOrder;             
        }
          this.docsImplementation.setHandler(this.globalService);
          try{
              this.docsImplementation.fecthData(docsUrl);
          }catch(exc){
            this.loggerService.log("exception handled for photos tab");
          }
    }


    onScrollDown(){
        var url = "";
        url = ENV_CONSTANTS.privateUrls[GlobalClassInstance.ENV_NAME]["nmsURL"] +  this.docsImplementation.docsnextLink;
        try{
        this.docsImplementation.createUrlForNextLinkOnDesktop(url);
        }
        catch(exc){
          this.loggerService.log("exception in scroll down")
        }
      }

    onMobileScrollDown(){
      var docheight = document.getElementById("documentWrapperId").scrollHeight;
      var toppos =  $(".scrollableContainer").scrollTop();
      var url = "";
        url = ENV_CONSTANTS.privateUrls[GlobalClassInstance.ENV_NAME]["nmsURL"] +  this.docsImplementation.docsnextLink;
        try{
        this.docsImplementation.createUrlForNextLinkOnMobile(docheight,toppos,url);
        }
        catch(exc){
          this.loggerService.log("exception in scroll down")
        }

      }
      
    
      decideScrollCall(event){
        if(!this.universalService.isMobileDevice && this.listService.docsRowDataSet){
          this.onScrollDown();
        }else if(this.universalService.isMobileDevice){
          this.onMobileScrollDown();
        }
      }

      async updateUIAfterPerformingAction(list,executedTask){
        var array = [];
        if(!this.universalService.nameSort){
          array = this.docsImplementation.sortedDocs;
        }else{
          array = this.universalService.sortByNameArray;
   
        }
        if(executedTask == 'TRASH' || executedTask == "MOVE"){ 
            if(executedTask == "MOVE" && this.universalService.selectedFolder.objectName == 'Private Folder')
              executedTask = "MOVETOPF"
            this.fileOperationsImplementation.setHandler(this.globalService);
            if(executedTask == 'TRASH'|| executedTask == "MOVETOPF"){
              var result = await this.fileOperationsImplementation.updateSummaryCountsAndUI(array,list,executedTask);
              this.docsImplementation.sortedDocs = result
            } else{
              this.listService.deSelectAll(null);
  
            }
        }else if(executedTask == 'RENAME' || executedTask == 'SETFAV' || executedTask == 'UNSETFAV' || executedTask == 'SHAREPERMISSION'){
            this.fileOperationsImplementation.setHandler(this.globalService);
            var result = await this.fileOperationsImplementation.updateOnlyTheUI(array, list,executedTask)
            this.docsImplementation.sortedDocs = result
        }else{
          this.universalService.showLoader = false;
        }
        if(array.length == 0)
          return "empty"
        else return "";
    }

    openPublicSort(sortType,reverseOrder){
      this.universalService.disableModalBackdrop();
      let sortTypeName = this.universalService.togglePublicSort(sortType,reverseOrder);
      if(sortTypeName!=""){
          this.sessionStorageService.setSharePublicSortPropName(sortTypeName);
      }
      //this.allFilesImplementation.allFilespreviousLink = "";
      this.getDocs();
      this.universalService.isMobileTopMoreOptionMenu = false;
      this.universalService.sharePublicSortByUploadDate = "";
  }

  selectAll(event){
    this.docsImplementation.selectAll(event)
  }

  async fetchNextPageData(){
    // if(this.docsImplementation.docsnextLink.length>0){
    //   var url = "";
    //   url = ENV_CONSTANTS.privateUrls[GlobalClassInstance.ENV_NAME]["nmsURL"] +  this.docsImplementation.docsnextLink;
    //   try{
    //     this.listService.disableSelectionModeInListView = true;
    //     var result = await this.docsImplementation.fetchNextPageData(url);
    //     if(result["resp"]["objects"].length == 0){
    //       this.universalService.showLoader = true;
    //       this.getDocs();
    //     }
      
    //   }
    //   catch(exc){
    //     this.loggerService.log("exception in scroll down")
    //   }
    // }else if(this.universalService.listView && !this.universalService.isMobileDevice && this.listService.listOptions.api.getDisplayedRowCount()==0){
    //   this.universalService.emptyTab = true;
    // } 

    this.getDocs();
    
  }
}


